import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  webType: 'pc',
  hideHeader: false,
  hideFooter: false,
  userInfo:null, // 用户信息
  accountInfo:null // 客户信息
}
const mutations = {
  setWebType(state, webType) {
    state.webType = webType
  },
  setHideHeader(state, hideHeader) {
    state.hideHeader = hideHeader
  },
  setHideFooter(state, hideFooter) {
    state.hideFooter = hideFooter
  },
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js